import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Wrapper, SIZE } from '@components/Preloader/style';

export { SIZE } from '@components/Preloader/style';

const Preloader = ({ size }) => (
  <Wrapper size={size}>
    <Icon src="/images/icons/loading.svg" alt="loading" />
  </Wrapper>
);

Preloader.defaultProps = {
  size: SIZE.NORMAL,
};

Preloader.propTypes = {
  size: PropTypes.oneOf(Object.values(SIZE)),
};

export default Preloader;
